import { type CategoryFacet } from "@/stf.data/schema";

import {
  type QueryParams,
  type RefinementList,
} from "./typed";

interface RefinementListMapperProps {
  categoryAttribute: CategoryFacet[];
  categoryVariant: CategoryFacet[];
}

const refinementListMapper = (props: RefinementListMapperProps) => {
  const {
    categoryAttribute,
    categoryVariant,
  } = props;

  return {
    createURL: (refinementList: RefinementList): QueryParams => {
      const queryParams: QueryParams = {};

      if (!refinementList) {
        return queryParams;
      }

      categoryAttribute.forEach((c) => {
        if (c.facetType === "refinementList" && c.filterable) {
          const uiKey = `productAttributeDict.${c.label}`;
          const queryKey = `a.${c.slug}`;

          const refinementValue = refinementList[uiKey];
          if (refinementValue) {
            queryParams[queryKey] = refinementValue;
          }
        }
      });
      categoryVariant.forEach((c) => {
        if (c.facetType === "refinementList" && c.filterable) {
          const uiKey = `variantSku.variantDisplay.${c.label}`;
          const queryKey = `v.${c.slug}`;

          const refinementValue = refinementList[uiKey];
          if (refinementValue) {
            queryParams[queryKey] = refinementValue;
          }
        }
      });

      // for creating shop pathname, we won't need to create url here
      // since ui won't support (for now)

      return queryParams;
    },
    parseURL: (pathname: string, queryParams: QueryParams | undefined): RefinementList => {
      if (!queryParams && pathname === "/search") {
        return undefined;
      }

      const refinementList: RefinementList = {};

      // getting shop refinement from parsing url
      // ie. getting "stack-coffee" from "/shop/stack-coffee"
      const regex = /^\/(?:\w{2}\/)?shop\/([a-z0-9-]+)$/u;
      const match = pathname.match(regex);
      const shop = match ? match[1] : null;
      if (shop) {
        refinementList["shopDetail.shopSlug"] = [shop];
      }

      if (queryParams) {
        categoryAttribute.forEach((c) => {
          if (c.facetType === "refinementList" && c.filterable) {
            const uiKey = `productAttributeDict.${c.label}`;
            const queryKey = `a.${c.slug}`;

            const queryParamsVal = queryParams[queryKey];

            if (queryParamsVal && Array.isArray(queryParamsVal)) {
              const attributeList = queryParamsVal.filter((v) => {
                return typeof v === "string";
              });
              refinementList[uiKey] = attributeList;
            }
            if (queryParamsVal && typeof queryParamsVal === "string") {
              refinementList[uiKey] = [queryParamsVal];
            }
          }
        });
        categoryVariant.forEach((c) => {
          if (c.facetType === "refinementList" && c.filterable) {
            const uiKey = `variantSku.variantDisplay.${c.label}`;
            const queryKey = `v.${c.slug}`;

            const queryParamsVal = queryParams[queryKey];

            if (queryParamsVal && Array.isArray(queryParamsVal)) {
              const attributeList = queryParamsVal.filter((v) => {
                return typeof v === "string";
              });
              refinementList[uiKey] = attributeList;
            }
            if (queryParamsVal && typeof queryParamsVal === "string") {
              refinementList[uiKey] = [queryParamsVal];
            }
          }
        });
      }

      return refinementList;
    },
  };
};

export {
  refinementListMapper,
};
